import React from 'react'
import ListItem from '../../../../../reusableComponents/baseListItems/baseList13'
import Button from '../../../../../reusableComponents/buttons/button22';
import ml from "../../../../../../assets/learnings/courses/completedCourses/ml.png";
import swift from "../../../../../../assets/learnings/courses/completedCourses/swift.png";
 
const CustomizableList = ({
    items = [],
    width = 'w-full',
    className = "",
    gap = "",
    renderRightComponent = () => null
}) => {
    return (
        <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 ${className}`}>
            {items.map((item, index) => (
                <div key={index} className="w-full">
                    <ListItem
                        image={item.image}
                        label={item.label}
                        showLabel={item.showLabel}
                        title={item.title}
                        showDescription={item.showDescription}
                        description={item.description}
                        width={width}
                    >
                        {renderRightComponent(item, index)}
                    </ListItem>
                </div>
            ))}
        </div>
    );
};

const CompletedCoursesList = () => {
    const enrolledCourses = [
        // {
        //     image: ml,
        //     label: "Completed",
        //     showLabel: true,
        //     title: "Machine Learning",
        //     showDescription: true,
        //     description: "15 February 2025",
        // },
        // {
        //     image: swift,
        //     label: "Completed",
        //     showLabel: true,
        //     title: "Swift",
        //     showDescription: true,
        //     description: "28 January 2025",
        // }
    ];

    // For testing, you can set this to an empty array
    // const enrolledCourses = [];

    const renderRightComponent = (item, index) => {
        // Define different onClick behaviors based on item title
        const getClickHandler = () => {
            switch (item.title) {
                case "Machine Learning":
                    return () => console.log(`Viewing certificate for Machine Learning course`);
                case "Swift":
                    return () => console.log(`Viewing certificate for Swift course`);
                default:
                    return () => console.log(`Viewing certificate for ${item.title}`);
            }
        };

        // Return consistent button with different onClick handlers
        return (
            <Button
                text="View Certificate"
                state="Default"
                type="Secondary"
                variant="Default"
                onClick={getClickHandler()}
                className="text-sm sm:text-base lg:text-lg whitespace-nowrap"
            />
        );
    }

    // Check if there are any completed courses
    if (enrolledCourses.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center pt-4 text-center">
                <p className="text-xl text-gray-600 font-medium">You have not completed any courses yet.</p>
                <p className="mt-2 text-gray-500">Completed courses will appear here when you finish them.</p>
            </div>
        );
    }

    return (
        <>
            <CustomizableList
                items={enrolledCourses}
                width="w-full"
                renderRightComponent={renderRightComponent}
            />
        </>
    )
}

export default CompletedCoursesList